export default "__VITE_ASSET__DHC8Adye__"